import { render } from "./MedicarePartA.vue?vue&type=template&id=f465cc26&scoped=true"
import script from "./MedicarePartA.vue?vue&type=script&lang=js"
export * from "./MedicarePartA.vue?vue&type=script&lang=js"

import "./MedicarePartA.vue?vue&type=style&index=0&id=f465cc26&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f465cc26"]])

export default __exports__